var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2108 12.7113L11.1054 12.2545L10.6486 12.1491L3.35253 10.4654C3.11226 10.4099 3.08886 10.0769 3.319 9.98843L19.1292 3.90761C19.3314 3.82985 19.5301 4.0285 19.4523 4.23069L13.3715 20.0409C13.283 20.271 12.95 20.2476 12.8945 20.0074L11.2108 12.7113Z",
    stroke: "#000",
    strokeWidth: 1.5
  })));
};

export default SvgLocation;